// extracted by mini-css-extract-plugin
export var lg = "_2f-4";
export var md = "_2f-3";
export var sm = "_2f-2";
export var xs = "_2f-1";
export var xxs = "_2f-0";